
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/labels/[slug]",
      function () {
        return require("private-next-pages/labels/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/labels/[slug]"])
      });
    }
  